import { batch } from 'react-redux';

import { SHIPMENT_EXPRESS_GET_ENABLE } from 'pages/Checkout/constants/apis.constant';
import {
  EExpressActionTypes,
  IExpress,
  TExpressAction,
  TExpressDispatch,
} from 'pages/Checkout/types/express.types';
import { TApiMiddlewareDispatch } from 'config/redux/middlewares/api.middleware.types';
import { IAppState } from 'config/redux/reducers';

import {
  fetchSelectedSlot,
  resetSlots,
  setSelectedSlot,
} from 'common/DeliverySlot/redux/deliverySlot.action';
import { getEarnedPoints, updateCart } from 'pages/Cart/redux/actions/getCart.action';
import { fetchPaymentModes } from './payment.action';
import EPaymentMethods from 'pages/Checkout/components/Payment/PamentMethods.enum';
import { removeRedeemedLoyaltyPoints } from 'pages/Checkout/components/LoyaltyPoints/redux/LoyaltyPoints.actions';
import { getCartId } from 'pages/Cart/helpers/url.helpers';
import { extractBinFromCard } from 'pages/Checkout/components/Payment/helpers/payment.helpers';

export const setExpressLoading = (loading: IExpress['loading']): TExpressAction => ({
  type: EExpressActionTypes.SHIPMENT_EXPRESS_SET_LOADING,
  payload: { loading },
});

export const setExpressError = (error: IExpress['error']): TExpressAction => ({
  type: EExpressActionTypes.SHIPMENT_EXPRESS_SET_ERROR,
  payload: { error },
});

export const expressGetEnable = (expressEnable: boolean, isFetchSlot = false) => (
  dispatch: TApiMiddlewareDispatch & TExpressDispatch,
  getState: () => IAppState
) => {
  dispatch(setExpressLoading(true));

  // Revert error only if needed
  const {
    checkout: {
      shipment: {
        express: { error },
      },
      payment: {
        paymentMode: { type: paymentMode },
        paymentDetails,
      },
    },
    appConfig: { areaCode },
  } = getState();

  const { totalPointsValue } = getState().loyalty;

  if (error) {
    dispatch(setExpressError(''));
  }
  const { saved = false, card_number = '', id = '' } = paymentDetails || {
    saved: false,
    card_number: '',
    id: '',
  };

  const areacode = areaCode;
  const binCode = saved ? `CARD-${id}` : extractBinFromCard(card_number) || '';

  dispatch({
    type: EExpressActionTypes.SHIPMENT_EXPRESS_GET_EXPRESS_ENABLE,
    payload: {
      enableProgress: false,
      onSuccess: (data: any) => {
        const {
          totalPriceWithTax: { value: cartTotalAmount },
          loyaltyVouchers,
        } = data;
        if (cartTotalAmount < 0 && loyaltyVouchers.length > 0) {
          removeRedeemedLoyaltyPoints(totalPointsValue > cartTotalAmount)(dispatch, getState);
        }
        // fetch payment mode
        fetchPaymentModes({
          currentPaymentMode: paymentMode as EPaymentMethods,
          isFetchCreditCards: true,
        })(dispatch, getState);

        // Fetch slots for the first time
        if (isFetchSlot) {
          dispatch(fetchSelectedSlot(areacode, getCartId(getState())) as any);
        } else if (data.deliverySlot) {
          const dispatchObject = {
            selectedSlot: data.deliverySlot,
            deliveryMessage: '',
            slotValidationRequired: true,
          };

          dispatch(setSelectedSlot(dispatchObject) as any);
        }

        // Refetch Cart
        dispatch(updateCart(dispatch, data) as any);
        dispatch(resetSlots() as any);
      },
      onFailure: (apiErrMsg: any, apiEr: any) => {
        const message = ((((apiEr.response || {}).data || {}).errors || [])[0] || {}).message;
        dispatch(setExpressError(message || apiErrMsg));
      },
      onFinally: () => {
        batch(() => {
          dispatch(getEarnedPoints() as any);
          dispatch(setExpressLoading(false));
        });
      },
      params: {
        areacode,
        expressEnable,
        cartId: getCartId(getState()),
        binCode,
      },
      url: SHIPMENT_EXPRESS_GET_ENABLE,
    },
  });
};
